export default "__VITE_ASSET__AXqWt3Ta__"